import React from 'react'
import { AppState, Auth0Provider } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'

function AuthProvider(props: any) {
    const { children } = props
    const nevigate = useNavigate()

    function handleRedirectCallback(appState?: AppState) {
        nevigate(appState?.returnTo || window.location.pathname)
    }

    const AUTH0_CLIENT_ID = 'lSMmH7nmoryDEp4dIo5JAG7QpCDpTFiy'
    const AUTH0_DOMAIN = 'https://discovertech.us.auth0.com'


    return (
        <Auth0Provider
            clientId={AUTH0_CLIENT_ID}
            domain={AUTH0_DOMAIN}
            onRedirectCallback={handleRedirectCallback}
            redirectUri={`${window.location.origin}/redirect`}
        >
            {children}
        </Auth0Provider>
    )
}

export default AuthProvider
